import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { ConnectedApplications } from '~src/connectedApplications/resources/ConnectedApplicationsResource';

import { imgPath } from '../../common/utilities/ImgUrl';
import { IGetConnectedApplicationsSecretResult } from '../serverApi/requests/GetSecretValueById';
import { SecretDisplayBoxActionButton } from './SecretDisplayBoxActionButton';

export interface SecretDisplayBoxProps {
    appId: string;
    appName: string;
    secretId: string;
    createdAt: string;
    rerenderCallback: (secretId: string) => void;
}

export interface SecretDisplayBoxState {
    showingPassword: boolean;
}

export class SecretDisplayBox extends React.Component<SecretDisplayBoxProps, SecretDisplayBoxState> {
    private readonly maskedPassword: string = '***************************';
    private secretValue: string = '';

    public constructor(props: SecretDisplayBoxProps) {
        super(props);
        this.state = { showingPassword: false };
    }

    protected imageClick() {
        if (!this.state.showingPassword) {
            ConnectedApplications.getSecret(this.props.appId, this.props.secretId).then(
                (result: IGetConnectedApplicationsSecretResult) => {
                    this.secretValue = result.connectedApplicationSecret.value;
                    this.setState({ showingPassword: !this.state.showingPassword });
                });
        }
        else {
            this.setState({ showingPassword: !this.state.showingPassword });
            this.secretValue = '';
        }
    }

    public render(): JSX.Element {
        const generatedTimeTextStyle = style({
            fontWeight: 'bold'
        });

        //This div is for drawing the border line
        const displayBoxStyle: React.CSSProperties = {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: CommonStyles.Colors.Grey225,
            marginBottom: '5px'
        };

        // The nested 3-row table relative to its outside div (border line)
        const tableStyle = style({
            paddingBottom: TabStyles.Spacing.MediumSpace,
            tableLayout: 'fixed',
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: TabStyles.Spacing.MediumSpace
        });

        const actionButtonStyle = style({
            float: 'right',
        });

        const valueFieldStyle = style({
            marginLeft: TabStyles.Spacing.LargeSpace,
            marginRight: TabStyles.Spacing.SmallSpace,
            overflowWrap: 'anywhere',
            whiteSpace: 'nowrap'
        });

        const iconButtonStyle = style({
            whiteSpace: 'nowrap'
        });

        return <div style={displayBoxStyle}>
            <table className={tableStyle}>
                <tbody>
                    <tr data-test-id="date_action_row">
                        <td>
                            <span className={generatedTimeTextStyle}>{Messages.connectedApplicationsSecretGeneratedOn({
                                TIME: new Date(this.props.createdAt).toLocaleDateString('en-US',{ year: 'numeric', month: 'long', day: '2-digit' })
                            })}</span>
                        </td>
                        <td className={actionButtonStyle}>
                            <SecretDisplayBoxActionButton
                                appId={this.props.appId}
                                appName={this.props.appName}
                                secretId={this.props.secretId}
                                secretValue={this.secretValue}
                                rerenderCallback={this.props.rerenderCallback}
                            />
                        </td>
                    </tr>
                    <tr data-test-id="secret_id_row">
                        <span>{Messages.connectedApplicationsSecretId()}</span>
                        <span className={valueFieldStyle}>{this.props.secretId}</span>
                    </tr>
                    {!this.state.showingPassword &&
                        <tr data-test-id="secret_not_showing_password_row">
                            <div className={iconButtonStyle}>
                            <span>{Messages.connectedApplicationsSecretValue()}</span>
                            <span className={valueFieldStyle}>{this.maskedPassword}</span>
                            <span className={iconButtonStyle}><input type='image' title={Messages.connectedApplicationsSecretShow()} src={imgPath('show_password_16px.svg')} alt={''} onClick={() => this.imageClick()}></input></span>
                            </div>
                        </tr>}
                    {this.state.showingPassword &&
                        <tr data-test-id="secret_showing_password_row">
                            <div className={iconButtonStyle}>
                            <span>{Messages.connectedApplicationsSecretValue()}</span>
                            <span className={valueFieldStyle}>{this.secretValue}</span>
                            <span className={iconButtonStyle}><input type='image' title={Messages.connectedApplicationsSecretHide()} src={imgPath('hide_password_16px.svg')} alt={''} onClick={() => this.imageClick()}></input></span>
                            </div>
                        </tr>
                    }
                </tbody>
            </table>
        </div>;
    }
}
